// Configuration de la navigation latérale.
// Aucun terme comptable technique brut n'est exposé inutilement.
import {
  LayoutDashboard,
  BookOpenCheck,
  Users,
  Building2,
  FileText,
  CheckCircle2,
  Settings,
  HelpCircle,
} from "lucide-react";

export const NAVIGATION = [
  {
    cle: "tableau-de-bord",
    libelle: "Tableau de bord",
    icone: LayoutDashboard,
    chemin: "/tableau-de-bord",
  },
  {
    cle: "journaux",
    libelle: "Journaux",
    icone: BookOpenCheck,
    // Visible pour tous les profils (la saisie est contrôlée côté serveur).
    sousMenu: [
      { libelle: "VT — Ventes", chemin: "/journaux/ventes" },
      { libelle: "AC — Achats", chemin: "/journaux/achats" },
      { libelle: "BQ — Banque", chemin: "/journaux/banque" },
      { libelle: "CA — Caisse", chemin: "/journaux/caisse" },
      { libelle: "OD — Opérations Diverses", chemin: "/journaux/od" },
      { libelle: "ODS — OD Salaires", chemin: "/journaux/od-salaires" },
    ],
  },
  {
    cle: "tiers",
    libelle: "Tiers",
    icone: Users,
    roles: ["gerant", "administrateur", "comptable", "saisisseur"],
    sousMenu: [
      { libelle: "Clients", chemin: "/tiers/clients" },
      { libelle: "Fournisseurs", chemin: "/tiers/fournisseurs" },
      { libelle: "Lettrage", chemin: "/tiers/lettrage" },
    ],
  },
  {
    cle: "etats",
    libelle: "États",
    icone: FileText,
    roles: ["gerant", "administrateur", "comptable", "expert_comptable"],
    sousMenu: [
      { libelle: "Balance générale", chemin: "/etats/balance" },
      { libelle: "Grand livre", chemin: "/etats/grand-livre" },
      { libelle: "Livres de journaux", chemin: "/etats/journaux" },
      { libelle: "Compte de résultat", chemin: "/etats/compte-de-resultat" },
      { libelle: "Bilan", chemin: "/etats/bilan" },
      { libelle: "Déclaration TVA", chemin: "/etats/declaration-tva" },
    ],
  },
  {
    cle: "rapprochements",
    libelle: "Rapprochements",
    icone: CheckCircle2,
    roles: ["gerant", "administrateur", "comptable"],
    chemin: "/rapprochements/banque",
  },
  {
    cle: "immobilisations",
    libelle: "Immobilisations",
    icone: Building2,
    module: "immobilisations",
    roles: ["gerant", "administrateur", "comptable", "saisisseur", "expert_comptable"],
    sousMenu: [
      { libelle: "Fichier des immobilisations", chemin: "/immobilisations/fichier" },
      { libelle: "Tableau des amortissements", chemin: "/immobilisations/tableau" },
      { libelle: "Générer les dotations", chemin: "/immobilisations/dotations" },
    ],
  },
  {
    cle: "parametres",
    libelle: "Paramètres",
    icone: Settings,
    chemin: "/parametres",
  },
  {
    cle: "aide",
    libelle: "Aide",
    icone: HelpCircle,
    chemin: "/aide",
  },
];
